import React from 'react';
import { InputBase, CustomDateInput } from '../../../Helper/InputBase';
import { formatter } from '../../../../utility';
import { NormalizationConstants } from '../../../../constants';
import appConstants from '../../../../config/app_config';
import moment from 'moment';

const DecisionQuestions = (props) => {
  const { userAccessDate, decisionDate, minDecisionDate, decisionEligibleAmount, decisionRentAmount, errors, handleChange, handleDateChange, handleDecisionDateChange, disabled } = props;

  return (
    <div className="decision-questions">
      <div className="decision-questions__input-wrapper">
        <CustomDateInput
          name='userAccessDate'
          disabled={!appConstants.testMode || disabled}
          value={userAccessDate}
          cssClass='decision-questions__userAccessDate'
          label={`Today's date`}
          handleChange={handleDateChange}
        />
      </div>

      <div className="decision-questions__input-wrapper">
        <CustomDateInput
          name='decisionDate'
          disabled={disabled}
          value={decisionDate}
          errors={errors.decisionDate}
          cssClass='decision-questions__decisionDate'
          minDate={appConstants.testMode ? null : moment(minDecisionDate).toDate()}
          maxDate={moment().toDate()}
          label='What is the date on the Residential Tenancy Branch decision?'
          handleChange={handleDecisionDateChange}
        />
      </div>

      <div className="decision-questions__input-wrapper">
        <InputBase
          name='decisionEligibleAmount'
          startAdornment='$'
          disabled={disabled}
          errors={errors.decisionEligibleAmount}
          value={decisionEligibleAmount}
          cssClass='decision-questions__eligible-amount'
          type='number'
          label='What is the total eligible amount in the decision for this rental unit?'
          maxLength={NormalizationConstants.maxDollarLength}
          handleChange={handleChange}
        />
      </div>

      <div className="decision-questions__input-wrapper">
        <InputBase
          name='decisionRentAmount'
          startAdornment='$'
          disabled={disabled}
          errors={errors.decisionRentAmount}
          value={decisionRentAmount}
          cssClass='decision-questions__rent-amount'
          type='number'
          label={`What was the rent amount on the date of the Residential Tenancy Branch decision${decisionDate ? ` (${formatter.toDateDisplay(decisionDate)})` : ''}?`}
          maxLength={NormalizationConstants.maxDollarLength}
          handleChange={handleChange}
        />
      </div>
    </div>
  )
}

export default DecisionQuestions;